import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './_styles.scss';

class SuperhighlightChannels extends Component {
  render() {
    const { highlight = {} } = this.props;
    const { 
      title = '', 
      image_highlight = '' 
    } = highlight || {};

    const showHighlight = image_highlight && image_highlight !== ''

    return (
      <div className="superhighlight-channels">
        { showHighlight && (
          <img 
            src={image_highlight} 
            alt={title} 
            className='superhighlight-channels__poster' 
          />
        )}        
      </div>
    );
  }
}

SuperhighlightChannels.propTypes = {
  highlight: PropTypes.object,
};

SuperhighlightChannels.defaultProps = {
  highlight: {},
};

export default SuperhighlightChannels;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialChannels/Components/SuperhighlightChannels/index.jsx